import React from "react";
import { API_URL } from "../../../constants/api";
import { apiPost } from "../../../utils/api_service";
import { ShowToast, toastType } from "../../../utils/toast-service";

class ContactUs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: undefined,
      name: undefined,
      question: undefined,
    };
  }

  /** Call on save click to validate fields */
  sendInfo = () => {
    const pattern = new RegExp(/^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/);

    if (
      this.state.name == null ||
      this.state.name == undefined ||
      this.state.name == ""
    ) {
      ShowToast("Please enter full name", toastType.ERROR, 5000, 200);
      return false;
    } else if (
      this.state.email == null ||
      this.state.email == undefined ||
      this.state.email == ""
    ) {
      ShowToast("Please enter email", toastType.ERROR, 5000, 200);
      return false;
    } else if (
      this.state.question == null ||
      this.state.question == undefined ||
      this.state.question == ""
    ) {
      ShowToast(
        "Please enter the question's answer",
        toastType.ERROR,
        5000,
        200
      );
      return false;
    }

    if (pattern.test(this.state.email) == false) {
      ShowToast("Please enter valid email", toastType.ERROR, 5000, 200);
      return false;
    }
    const postBody = {
      email: this.state.email,
      name: this.state.name,
      question: this.state.question,
    };
    apiPost({
      url: API_URL.tenant.ContactUs,
      postBody: postBody,
    }).then((response) => {
      if (response.data.success == false) {
        ShowToast(response.data.message, toastType.ERROR, 5000, 200);
      } else if (response.data.success == true) {
        ShowToast(
          "Your question has been sent successfully",
          toastType.SUCCESS,
          5000,
          200
        );
        this.props.resetPassword("logIn");
      }
    });
  };

  /** Set values */
  setValues = (value, FieldName) => {
    if (FieldName == "name") {
      this.setState({ name: value });
    } else if (FieldName == "email") {
      this.setState({ email: value });
    } else {
      this.setState({ question: value });
    }
  };

  render() {
    return (
      <div>
        <div>
          <label>{"Full Name"}</label>
          <br />
          <input
            type={"text"}
            name={"Full Name"}
            className={"text-field bg-login bgImgSet"}
            onBlur={(event) => {
              this.setValues(event.target.value, "name");
            }}
          />
        </div>
        <div>
          <label>{"Email Address"}</label> <br />
          <input
            type={"email"}
            name={"Email Address"}
            className={"text-field bg-email bgImgSet"}
            onBlur={(event) => {
              this.setValues(event.target.value, "email");
            }}
          />
        </div>
        <div>
          <label>{"Questions"}</label> <br />
          <textarea
            style={{ height: "auto" }}
            name={"Questions"}
            className={"text-field "}
            rows={"4"}
            onBlur={(event) => {
              this.setValues(event.target.value, "question");
            }}
          />
        </div>

        <div style={{ marginTop: "15px" }}>
          <button type={"button"} className={"login-button"} onClick={() => this.sendInfo()}>
            {"Submit\r"}
          </button>
        </div>
      </div>
    );
  }
}

export default ContactUs;
